export { default } from "./OwaImage";
export { default as LegacyOwaImage } from "./LegacyOwaImage";
export type { OwaImageProps } from "./OwaImage";
export type { LegacyOwaImageProps } from "./LegacyOwaImage";
